// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"7fdadf2d","324":"e92bfbb7","384":"3bc01d4c","486":"88dd0b14","489":"60554935","744":"f55ceeb0","772":"36ed04ee","937":"a25a4443"}[chunkId] + ".chunk.js";
};